import { WebStorageStateStore, WebStorageStateStoreSettings, UserManager } from 'oidc-client';
const appConfig = require('appConfig');

const host = `${window.location.origin}`;
const userStoreSettings: WebStorageStateStoreSettings = 
{ store: window.sessionStorage, prefix: 'oidc.' };
const userStore: WebStorageStateStore = new WebStorageStateStore(userStoreSettings);

const config = {
  ...appConfig.userManager,
  userStore,
  redirect_uri: `${host}/auth`,
  silent_redirect_uri: `${host}/silent_auth.html`,
};

const userManager = new UserManager(config);
export default userManager;




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/userManager.ts